import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { VehicleAssignmentDTO, VehicleAssignmentResponseModel, VehicleAssignStatusDTO } from '@gtpl/shared-models/transportation';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { VehicleAssignmentAdapter } from './dto/vehicle-assignment-adapter';
import { VehicleAssignmentDto } from './dto/vehicle-assignment.dto';
import { VehicleAssignment } from './vehicle-assignment.entity';
import { IndentService } from '@gtpl/shared-services/raw-material-procurement'
import { IndentRequest } from './dto/indent.request';
let moment = require('moment');
@Injectable()
export class VehicleAssignmentService {
    constructor(
        @InjectRepository(VehicleAssignment)
        private vehicleAssignmentRepository: Repository<VehicleAssignment>,
        private vehicleAssignmentAdapter: VehicleAssignmentAdapter,
        private indentService: IndentService,
    ) { }

    async getVehicleAssignDetailsByIndentId(indentRequest: IndentRequest): Promise<VehicleAssignmentResponseModel> {
        try {
            const vehicleDetails = await this.vehicleAssignmentRepository.findOne({ where: { indentId: indentRequest.indentId }, order: { vehicleAssignId: 'DESC' } });
            const savedVehAssignmentDto: VehicleAssignmentDTO = this.vehicleAssignmentAdapter.convertEntityToDto(vehicleDetails);
            if (savedVehAssignmentDto) {
                const response = new VehicleAssignmentResponseModel(true, 11101, 'Vehicle Assignment retrived Successfully', savedVehAssignmentDto);
                return response;
            }
            else {
                const response = new VehicleAssignmentResponseModel(false, 11101, 'no data  found', savedVehAssignmentDto);
                return response;
            }

        } catch (error) {
            return error;
        }
    }
    async createVehicleAssignment(vehicleAssignmentDto: VehicleAssignmentDto, isUpdate: boolean, request: Request): Promise<VehicleAssignmentResponseModel> {
        try {
            console.log(isUpdate);
            // if (!isUpdate) {
            //     const VehicleEntity = await this.getVehAssignmentDetails(vehicleAssignmentDto.driverId,vehicleAssignmentDto.vehicleId,vehicleAssignmentDto.harvestingDate,vehicleAssignmentDto.harvestingTime,vehicleAssignmentDto.indentId);
            //     console.log(VehicleEntity);
            //     if (VehicleEntity.driverStatus && !VehicleEntity.vehicleStatus) {
            //         throw new ErrorResponse(11104, 'Driver already assigned for same harvesting date time. ');         
            //     } 
            //     else if (!VehicleEntity.driverStatus && VehicleEntity.vehicleStatus) {
            //         throw new ErrorResponse(11104, 'Vehicle already assigned for same harvesting date time. ');         
            //     } 
            //     else if (VehicleEntity.driverStatus && VehicleEntity.vehicleStatus) {
            //         throw new ErrorResponse(11104, 'Driver & Vehicle already assigned for same harvesting date time. ');         
            //     } 
            // }
            const convertedVehAssignmentEntity: VehicleAssignment = this.vehicleAssignmentAdapter.convertDtoToEntity(vehicleAssignmentDto, isUpdate);

            const savedDepartmentEntity: VehicleAssignment = await this.vehicleAssignmentRepository.save(
                convertedVehAssignmentEntity
            );


            const savedVehAssignmentDto: VehicleAssignmentDTO = this.vehicleAssignmentAdapter.convertEntityToDto(savedDepartmentEntity);

            if (savedVehAssignmentDto) {
                // generating resposnse
                const updateVehStatus = await this.indentService.updateVehicleStatus({ indentId: savedVehAssignmentDto.indentId, vehicleAssigned: true });

                if (updateVehStatus) {
                    const response = new VehicleAssignmentResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Vehicle Assignment Updated Successfully' : 'Vehicle Assigned Successfully', savedVehAssignmentDto);
                    return response;
                }
                else {
                    throw new ErrorResponse(11106, 'vehicle not assigned, something went wrong. ');
                }

            } else {
                throw new ErrorResponse(11106, 'Vehicle Assigned but issue while transforming into DTO');
            }
        } catch (error) {
            return error;
        }
    }

    async getVehAssignmentDetails(driverId: number, vehicleId: number, harvestingDate: Date, harvestingTime: HarvestingTime, indentId: number): Promise<VehicleAssignStatusDTO> {
        const harvestDateData = moment(harvestingDate).format('YYYY-MM-DD')
        let vehicleStatus = false;
        let driverStatus = false;
        const vehicleCheck = await this.vehicleAssignmentRepository.createQueryBuilder("VehicleAssignment")
            .where("harvesting_date = '" + harvestDateData + "'")
            .andWhere("vehicle_id = " + vehicleId)
            .andWhere("indent_id != " + indentId)
            .andWhere("is_active = true")
            .andWhere("harvesting_time = '" + harvestingTime + "'").getRawMany();
        const driverCheck = await this.vehicleAssignmentRepository.createQueryBuilder("VehicleAssignment")
            .where("harvesting_date = '" + harvestDateData + "'")
            .andWhere("driver_id = " + driverId)
            .andWhere("indent_id != " + indentId)
            .andWhere("is_active = true")
            .andWhere("harvesting_time = '" + harvestingTime + "'").getRawMany();
        console.log('driverCheck' + driverCheck);

        if (vehicleCheck.length > 0) {
            vehicleStatus = true;
        }
        if (driverCheck.length > 0) {
            driverStatus = true;
        }
        return new VehicleAssignStatusDTO(vehicleStatus, driverStatus);
    }
}
